function ChiffresCles() {
  const cartes = [
    { logo: "./icons/calendrier.svg", titre: "Depuis", chiffre: "2007" },
    { logo: "./icons/etudiant.svg", titre: "Étudiants mobilisables", chiffre: "250" },
    { logo: "./icons/document.svg", titre: "Études réalisées", chiffre: "50" }
  ];

  return (
    <div id="chiffres_cles" className="overflow-hidden px-4">
      <div className="flex flex-col md:flex-row justify-evenly items-center md:items-stretch gap-6 md:gap-0">
        {cartes.map(({logo, titre, chiffre}, index) => (
          <div key={index} className="flex flex-col justify-between items-center h-[190px] w-full max-w-[250px]">
            <embed src={logo} type="" className="w-12 h-12 mb-4" />
            <h2 className="text-sky-800 dark:text-blanc-sombre text-xl font-bold text-center">{titre}</h2>
            <div className="overflow-hidden h-10 flex justify-center items-center">
              <span className="text-bleu-je text-xl font-bold">{chiffre}</span>
            </div>
            <div className="h-4" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ChiffresCles;